import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { selectBbox, selectData, selectStatus } from '../selectors';

import FilteredMap from './FilteredMap';
import Filter from '../Filter';
import Slider from '../Slider';

import { setSliderValue, setDataAsync } from '../reducers/mapDataSlice';

import './Map.css';

const pauseUrl = "https://uploads-ssl.webflow.com/6050a76fa6a633d5d54ae714/62cd878fbbd0fa0026413071_icon_pause.svg";
const playUrl = "https://uploads-ssl.webflow.com/6050a76fa6a633d5d54ae714/62cd8794dd340f80d67f3544_icon-play.svg";
const resetUrl = "https://uploads-ssl.webflow.com/6050a76fa6a633d5d54ae714/62cd878c96064a2a7b41491b_play-repeat.svg";

function MapContainer({ mode }) {
  const data = useSelector(state => selectData(state));
  const bbox = useSelector(state => selectBbox(state));
  const status = useSelector(state => selectStatus(state));
  const dispatch = useDispatch();

  var intervalId;

  const onLoadHandler = () => {
    dispatch(setDataAsync(mode));
  }

  const onSliderChange = (e) => {}

  const onPauseClick = () => { 
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = undefined;
    }
  }

  const onPlayClick = () => {
    if (!intervalId) {
      intervalId = setInterval(() => dispatch(setSliderValue()))
    }
  }

  const onResetClick = () => {
    onPauseClick();
    dispatch(setSliderValue(1));
  }

  const loaderContainerStyle = { 
    position: 'relative', 
    display: 'block', 
    width: '100%',
    height: '100%',
    textAlign: 'center', 
    zIndex: 50 
  };

  return (
    <div className="map-data-container flex">
      <div className="filter">
        <p className="">{ mode === 'Adasis' ? 'ADASISv2 View' : 'Data view' }</p>
        <Filter mode={mode} />
      </div>
      <div className="map">
        <FilteredMap data={data} bbox={bbox} mode={mode} onLoad={() => onLoadHandler()} />
        { /* status !== 'completed' && 
          <div style={{ ...loaderContainerStyle, top: '-100%' }}>
            <div style={{ ...loaderContainerStyle, opacity: 0.7, backgroundColor: '#FFF' }} />
            <div className="lds-dual-ring" style={{ position: 'relative', top: '-54%', zIndex: 90 }}></div>
          </div> */ }
        { mode === 'Adasis' && 
          <div className='adasis-trip-controller flex'>
            <Slider onChange={onSliderChange}/>
            <button onClick={onPauseClick}><img alt="pause" src={pauseUrl} /></button>
            <button onClick={onPlayClick}><img alt="play" src={playUrl} /></button>
            <button onClick={onResetClick}><img alt="reset" src={resetUrl} /></button>
          </div> }
      </div>
    </div>
  );
}

export default MapContainer;
